import Affix from './affix';
import Alert from './alert';
import Anchor from './anchor';
import AutoComplete from './auto-complete';
import Avatar from './avatar';
import BackTop from './back-top';
import Badge from './badge';
import Breadcrumb from './breadcrumb';
import Button from './button';
import Calendar from './calendar';
import Card from './card';
import Carousel from './carousel';
import Cascader from './cascader';
import Checkbox from './checkbox';
import Col from './col';
import Collapse from './collapse';
import Comment from './comment';
import DatePicker from './date-picker';
import Divider from './divider';
import Drawer from './drawer';
import Dropdown from './dropdown';
import Descriptions from './descriptions';
import Empty from './empty';
import Form from './form';
import Image from './image';
import Input from './input';
import InputNumber from './input-number';
import Layout from './layout';
import List from './list';
import Mentions from './mentions';
import Menu from './menu';
import message from './message';
import Modal from './modal';
import notification from './notification';
import Pagination from './pagination';
import PageHeader from './page-header';
import Popconfirm from './popconfirm';
import Popover from './popover';
import Progress from './progress';
import Radio from './radio';
import Result from './result';
import Rate from './rate';
import Row from './row';
import Select from './select';
import Skeleton from './skeleton';
import Slider from './slider';
import Space from './space';
import Statistic from './statistic';
import Spin from './spin';
import Steps from './steps';
import Switch from './switch';
import Table from './table';
import Tabs from './tabs';
import Tag from './tag';
import Timeline from './timeline';
import TimePicker from './time-picker';
import Tooltip from './tooltip';
import Transfer from './transfer';
import Tree from './tree';
import TreeSelect from './tree-select';
import Upload from './upload';
import Typography from './typography';
import ConfigProvider from  './config-provider';
import LocaleProvider from  './locale-provider';
export {
    Affix,
    Alert,
    Anchor,
    AutoComplete,
    Avatar,
    BackTop,
    Badge,
    Breadcrumb,
    Button,
    Calendar,
    Card,
    Carousel,
    Cascader,
    Checkbox,
    Col,
    Collapse,
    Comment,
    DatePicker,
    Descriptions,
    Divider,
    Drawer,
    Dropdown,
    Empty,
    Form,
    Input,
    InputNumber,
    Layout,
    List,
    Mentions,
    Menu,
    message,
    Modal,
    notification,
    Pagination,
    Popconfirm,
    Popover,
    Progress,
    Radio,
    Rate,
    Result,
    Row,
    Select,
    Skeleton,
    Slider,
    Spin,
    Steps,
    Switch,
    Table,
    Tabs,
    Tag,
    Timeline,
    TimePicker,
    Tooltip,
    Transfer,
    Tree,
    TreeSelect,
    Upload,
    Typography,
    Image,
    PageHeader,
    Space,
    Statistic,
    ConfigProvider,
    LocaleProvider,
}


// WEBPACK FOOTER //
// ./src/components/index.tsx